(function () {
  if (window.rochesterJobsApplicationInitialized) return;
  window.rochesterJobsApplicationInitialized = true;

  var lastTrigger = new WeakMap();

  function setTriggerState(panel, isExpanded) {
    var section = panel.closest('.rochester-jobs');

    if (!section) return;

    section.querySelectorAll('[data-rochester-application-open]').forEach(function (button) {
      if (button.getAttribute('aria-controls') === panel.id) {
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    });
  }

  function openApplication(button) {
    var panelId = button.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    if (!panel) return;

    lastTrigger.set(panel, button);
    panel.hidden = false;
    setTriggerState(panel, true);
    panel.focus({ preventScroll: true });
    panel.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function closeApplication(button) {
    var panel = button.closest('[data-rochester-application]');

    if (!panel) return;

    panel.hidden = true;
    setTriggerState(panel, false);

    var trigger = lastTrigger.get(panel);
    if (trigger) trigger.focus();
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-rochester-application-open]');
    if (openButton) {
      openApplication(openButton);
      return;
    }

    var closeButton = event.target.closest('[data-rochester-application-close]');
    if (closeButton) closeApplication(closeButton);
  });
})();
